import axios from 'axios'

const cachios = require('cachios')
const LRU = require('lru-cache')

cachios.getCacheIdentifier = config => ({
  method: config.method,
  url: config.url,
  params: config.params,
  data: config.data,
  headers: config.headers
})

cachios.cache = new LRU({
  max: 500,
  length: function (n, key) {
    return n * 2 + key.length
  },
  dispose: function (key, n) {
    n.close()
  },
  maxAge: 1000 * 60 * 3 // 3 min
})

export default (store, radio) => {
  // TODO: better localStorage management and state hydration
  const tokenGetter = () => localStorage.getItem('user-token') || ''

  const $http = axios.create({
    baseURL: process.env.VUE_APP_API_URL
  })

  $http.interceptors.request.use(
    config => {
      config.headers.authorization = 'Bearer ' + tokenGetter()
      config.headers['x-organisation-id'] = process.env.VUE_APP_ORGANISATION || 1 // TODO: make x-organisation-id header dynamic

      if (store.getters.storesLoaded && typeof store.getters.tenancy.id !== 'undefined') {
        config.headers['x-store-id'] = store.getters.tenancy.id
      }
      radio.$emit('api-loading', true)
      return config
    },
    error => Promise.reject(error)
  )

  $http.interceptors.response.use(
    function (response) {
      radio.$emit('api-loading', false)
      return response
    },
    async function (error) {
      if (error.response) {
        const {
          response: { status }
        } = error
        if (status === 401) {
          try {
            let refreshToken = localStorage.getItem('refresh-token')

            if (!refreshToken) {
              radio.$emit('api-loading', false)
              store.dispatch('auth/AUTH_LOGOUT').then(() => {
                radio.$emit('app-logout')
              })
              return Promise.reject(error)
            }

            let refreshTokenRequestBody = {
              grant_type: 'refresh_token',
              client_id: process.env.VUE_APP_ID,
              refresh_token: refreshToken
            }

            const response = await $http.post('/auth/v1/oauth/token', refreshTokenRequestBody)
            let date = new Date()
            let tokenExpiration = date.setSeconds(parseInt(date.getSeconds()) + parseInt(response.data.expires_in))

            localStorage.setItem('user-token', response.data.access_token)
            localStorage.setItem('refresh-token', response.data.refresh_token)
            localStorage.setItem('token-expiration', tokenExpiration)

            // resend failed request
            return $http.request(error.config)
          } catch (error) {
            radio.$emit('api-loading', false)

            store.dispatch('auth/AUTH_LOGOUT').then(() => {
              radio.$emit('app-logout')
            })
            return Promise.reject(error)
          }
        }
      }
      radio.$emit('api-loading', false)
      return Promise.reject(error)
    }
  )

  // return cachios.create($http)
  return $http // No cache
}
